<template>
	<div>
		<Billingcomponent
			:outerVisible="outerVisible"
			@closeouterVisible="closeouterVisible"
			:ruleFormb="allitem.ruleFormb"
			:priceall="allitem.priceall"
			:totalall="allitem.totalall"
			:ruleFormbxiao="allitem.ruleFormbxiao"
			:form_chae="allitem.form_chae"
			:bztext="allitem.bztext"
			:stateall="allitem.stateall"
			:listoflists="allitem.listoflists"
			:invoiceNo="allitem.invoiceNo"
			:documentStatus="documentStatus"
			:invoiceCode="allitem.invoiceCode"
			title="预览发票"
			:billingDate="allitem.billingDate"
			:checkCode="allitem.checkCode"
		></Billingcomponent>
		<!-- 高级查询 -->
		<kgdiag @closekgdialog="closekgdialog" :headtitle="kgtitle" :kgdialog="kgdialog" :tableDatans="tableDatans" :tableDatakp="tableDatakp"></kgdiag>
		<!-- 修改自定义说明二修改 -->
		<el-dialog title="修改自定义说明二" :visible.sync="dialogApproval" width="100px;" v-dialogDrag>
			<taxform :Formlist="formlist" ref="taxForm" :formdata="formdata"></taxform>
			<div style="justify-content: center;margin-top: 40px; display: flex;">
				<div class="backstyle" style="margin-right: 30px;margin-left: 30px; margin-bottom: 20px;" @click="dialogApproval = false">返回</div>
				<div class="addstyle" style="margin-bottom: 20px;" @click="submitFrom">提交</div>
			</div>
		</el-dialog>
		<el-tabs v-model="choosetitleindex" style="margin-left:16px;margin-top: 8px;" @tab-click="forchangetype">
			<el-tab-pane label="已开发票作废" name="0"></el-tab-pane>
			<!--   <el-tab-pane label="未开发票作废" name="1"></el-tab-pane> -->
			<el-tab-pane label="验签失败作废" name="2"></el-tab-pane>
		</el-tabs>
		<div v-if="choosetitleindex == '0'">
			<taxSearch :searchdata="serchform" :searchlist="searchlist" labelwidth="150px" labelPosition="left" @submitSearch="forshuai()"></taxSearch>
			<div class="headline"></div>
			<div class="areacontent">
				<div class="">
					<div class="Centerupdown">
						<!-- <el-button type="primary" plain @click="forshuai()" style="width: 100px;">查询</el-button> -->
						<!-- <div class="addstyle" @click="forshuai()" style="width: 100px;margin-right: 10px;"><samp>查询</samp></div> -->
						<!-- <el-button type="primary" plain @click="resetForm()" style="width: 100px;">重置</el-button> -->
						<!-- <div class="addstyle" @click="resetForm()" style="width: 100px;margin-right: 10px;"><samp>重置</samp></div> -->
						<!--						<el-button type="primary" plain @click="docInvalid" style="width: 100px;">-->
						<!--							作废-->
						<!--							<i class="el-icon-circle-close el-icon&#45;&#45;right"></i>-->
						<!--						</el-button>-->
						<el-dropdown>
							<!--          <el-button type="primary"  plain  style="width: 100px; padding-left:30px;margin-left: 10px"> 作废
                <i class="el-icon-caret-bottom el-icon--right" style="padding-left:8px;"></i></el-button> -->
							<div class="addstyle" style="width: 100px;margin-right: 10px;">
								<samp>
									作废
									<i class="el-icon-caret-bottom el-icon--right" style="padding-left:8px;"></i>
								</samp>
							</div>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item @click.native="docInvalid(1)">作废</el-dropdown-item>
								<el-dropdown-item @click.native="docInvalid(2)">作废重开</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>

						<div class="addstyle" @click="openUpdateZidysm2()" style="width: 130px;margin-right: 10px;"><samp>修改自定义说明二</samp></div>
						<!-- <el-button style="margin-left: 30px;" type="primary" plain @click="openUpdateZidysm2()">
              修改自定义说明二
            </el-button> -->
					</div>
					<!-- <div class="Centerupdown" >
				<el-input clearable style="width: 300px;margin-left: 20px;margin-right: 16px;" placeholder="购方名称、发票号码、金额" prefix-icon="el-icon-search" v-model="likeSearch" @input="forserchinput"></el-input>
				<el-button  class="moreserch" type="primary"     plain @click="forserch"  style="margin-right: 16px;">
					高级查询
					<i class="el-icon-search el-icon--right"></i>
				</el-button>
				</div> -->
				</div>
				<div class="areatable">
					<div class="">
						<el-table
							:data="tableData"
							border
							@selection-change="handleSelectionChange"
							@row-click="selectClick"
							style="width: 100%"
							ref="multipleTable"
							height="calc(100vh - 436px )"
							@sort-change="tableSortChange"
						>
							<el-table-column type="selection" width="55" fixed="left"></el-table-column>
							<el-table-column prop="danjh" label="单据号" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
							<el-table-column prop="fapzt" label="单据状态" min-width="100">
								<template slot-scope="scope">
									<!-- 发票状态 -1:草稿 0：入库保存；1：已审核；2：待开票；3：开票中；4：已开票；7：开票失败；8：暂不开票；9：已退票；34：无需开票 -->
									<p v-if="scope.row.fapzt == '-1'" style="color:#BEBEBE">草稿</p>
									<p v-if="scope.row.fapzt == '0'">待审核</p>
									<p v-if="scope.row.fapzt == '1'" style="color:#00DC16">已审核</p>
									<p v-if="scope.row.fapzt == '2'" style="color:#EE0101">待开票</p>
									<p v-if="scope.row.fapzt == '3'" style="color:#2F66FC">开票中</p>
									<p v-if="scope.row.fapzt == '4'" style="color:#FF8000">已开票</p>
									<p v-if="scope.row.fapzt == '5'" style="color:#FF8000">已作废</p>
									<p v-if="scope.row.fapzt == '6'" style="color:#FF8000">已红冲</p>
									<p v-if="scope.row.fapzt == '7'" style="color:#BEBEBE">开票失败</p>
									<p v-if="scope.row.fapzt == '8'" style="color:#00DC16">暂不开票</p>
									<p v-if="scope.row.fapzt == '9'" style="color:#00DC16">已退票</p>
									<p v-if="scope.row.fapzt == '10'" style="color:#00DC16">已合并</p>
									<p v-if="scope.row.fapzt == '21'" style="color:#00DC16">作废关闭中</p>
									<p v-if="scope.row.fapzt == '22'" style="color:#00DC16">作废重开中</p>
									<p v-if="scope.row.fapzt == '23'" style="color:#00DC16">作废锁定</p>
									<p v-if="scope.row.fapzt == '31'" style="color:#00DC16">未开发票冲销</p>
									<p v-if="scope.row.fapzt == '32'" style="color:#00DC16">已开发票冲销</p>
									<p v-if="scope.row.fapzt == '33'" style="color:#00DC16">作废冲销</p>
									<p v-if="scope.row.fapzt == '34'" style="color:#00DC16">无需开票</p>
									<p v-if="scope.row.fapzt == '35'" style="color:#00DC16">待作废</p>
								</template>
							</el-table-column>
							<el-table-column label="发票类型" prop="faplxdm" sortable="custom" min-width="100" align="center">
								<template slot-scope="scope">
									<p v-if="scope.row.faplxdm == '026'">电子普票</p>
									<p v-if="scope.row.faplxdm == '028'">电子专票</p>
									<p v-if="scope.row.faplxdm == '007'">纸质普票</p>
									<p v-if="scope.row.faplxdm == '004'">纸质专票</p>
								</template>
							</el-table-column>
							<el-table-column prop="fapdm" label="发票代码" sortable="custom" align="center" min-width="100"></el-table-column>
							<el-table-column prop="faphm" label="发票号码" sortable="custom" align="center" min-width="100">
								<template slot-scope="scope">
									<el-button type="text" @click="foryulan(scope.row)">{{ scope.row.faphm }}</el-button>
								</template>
							</el-table-column>
							<el-table-column prop="goufmc" label="购方名称" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
							<el-table-column prop="hejje" label="金额" align="right" min-width="100">
								<template slot-scope="scope">
									<span>{{ toThousands(Amountformat(scope.row.hejje)) }}</span>
								</template>
							</el-table-column>
							<el-table-column prop="hejse" label="税额" align="right" min-width="100">
								<template slot-scope="scope">
									<span>{{ toThousands(Amountformat(scope.row.hejse)) }}</span>
								</template>
							</el-table-column>
							<el-table-column label="开票日期" align="left" min-width="160px" show-overflow-tooltip>
								<template slot-scope="scope">
									<span>{{ yyyyMMdd(scope.row.kaiprq) }}</span>
								</template>
							</el-table-column>
							<el-table-column label="是否清单" align="center" width="100">
								<template slot-scope="scope">
									<p v-if="scope.row.hasList == '1'">是</p>
									<p v-else>否</p>
								</template>
							</el-table-column>
							<el-table-column label="主要商品名称" align="left" min-width="160px" show-overflow-tooltip>
								<template slot-scope="scope">
									<span v-if="notemptyandnull(scope.row.docDetails.length)">{{ scope.row.docDetails[0].shangpmc }}</span>
								</template>
							</el-table-column>
							<el-table-column prop="yuanfpdm" label="原发票代码" align="center" min-width="110"></el-table-column>
							<el-table-column prop="yuanfphm" label="原发票号码" align="center" min-width="110"></el-table-column>
							<el-table-column label="作废日期" align="left" min-width="160px" show-overflow-tooltip>
								<template slot-scope="scope">
									<span>{{ yyyyMMdd(scope.row.zfrq) }}</span>
								</template>
							</el-table-column>
							<el-table-column prop="zidysm" label="自定义说明" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
							<el-table-column prop="zidysm2" label="自定义说明二" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
							<el-table-column prop="kaipzddm" label="税盘编号" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
							<el-table-column fixed="right" label="操作" min-width="180" align="center">
								<template slot-scope="scope">
									<div class="Centerhorizontally">
										<el-button type="text" size="small" :style="scope.row.fapzt == '35' ? 'color:#BEBEBE' : ''" @click="docOneInvalid(scope.row, 1)">
											作废
										</el-button>
										<el-button type="text" size="small" @click="foryulan(scope.row)">预览发票</el-button>
										<el-button type="text" size="small" @click="docOneInvalid(scope.row, 2)">作废重开</el-button>
									</div>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="lastend">
						<div>
							当前已勾选
							<span>{{ selectCount }}</span>
							条
						</div>
						<div>
							合计金额
							<span>{{ toThousands(Amountformat(selectHejje)) }}</span>
						</div>
						<div>
							合计税额
							<span>{{ toThousands(Amountformat(selectHejse)) }}</span>
						</div>
					</div>
					<div class="buttompage">
						<el-pagination
							:key="elementui_page_component_key"
							:current-page="currentpage"
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:page-sizes="[10, 20, 100, 500]"
							:page-size="pagenum"
							layout="total, sizes, prev, pager, next, jumper"
							:total="totalcount"
						></el-pagination>
					</div>
				</div>
			</div>
		</div>
		<div v-if="choosetitleindex == '1'" class="zuofei">
			<div class="Centerupdown">
				<div>发票类型选择</div>
				<div>
					<el-select v-model="value" placeholder="请选择">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</div>
			</div>
			<div style="display: flex;">
				<div style="height: 500px;">
					<div class="Centerupdown">
						<div>发票代码</div>
						<div>
							<el-select v-model="value" placeholder="请选择">
								<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</div>
					</div>
				</div>
				<div style="height: 500px;">
					<div class="Centerupdown">
						<div>当前号码</div>
						<div>
							<el-select v-model="value" placeholder="请选择">
								<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</div>
					</div>
					<div class="Centerupdown">
						<div>终止号码</div>
						<div><el-input v-model="input" placeholder="请输入内容"></el-input></div>
					</div>
					<div class="Centerupdown">
						<div>当前剩余份数</div>
						<div><el-input v-model="input" placeholder="请输入内容"></el-input></div>
					</div>
					<div class="Centerupdown">
						<div>作废份数</div>
						<div><el-input v-model="input" placeholder="请输入内容"></el-input></div>
						<el-button type="primary" plain>确定作废</el-button>
					</div>
					<div class="tish"><div style="font-size: 13px;">作废发票号码:XXXXX</div></div>
					<div class="tish"><div style="font-size: 13px;">作废发票号码:XXXXX至XXXXX</div></div>
				</div>
			</div>
		</div>
		<div v-if="choosetitleindex == '2'" style="margin-left: 16px;margin-top: 16px;">
			<div class="Centerupdown" >
				<div class="between-line">
					<!-- <el-button type="primary" plain style="width: 100px;" @click="forshuai('yq')">查询</el-button> -->
					<div class="addstyle" @click="forshuai('yq')" style="width: 80px;margin-right: 10px;	"><samp>查询</samp></div>
					<!--			<el-button type="primary" plain style="width: 100px;" @click="docInvalid">作废</el-button>-->
					<el-dropdown>
						<!--  <el-button type="primary"  plain  style="width: 100px; padding-left:30px;"> 作废
          <i class="el-icon-caret-bottom el-icon--right" style="padding-left:8px;"></i></el-button> -->
						<div class="addstyle" style="width: 90px;">
							<samp>
								作废
								<i class="el-icon-caret-bottom el-icon--right" style="padding-left:8px;"></i>
							</samp>
						</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="docInvalid(1)">作废</el-dropdown-item>
							<el-dropdown-item @click.native="docInvalid(2)">作废重开</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>
			<el-table
				:data="tableData"
				border
				@selection-change="handleSelectionChange"
				@row-click="selectClick"
				style="width: 100%;margin-top: 20px;"
				ref="multipleTable"
				height="calc(100vh - 260px )"
				@sort-change="tableSortChange"
			>
				<el-table-column type="selection" width="55" fixed="left"></el-table-column>
				<el-table-column prop="danjh" label="单据号" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
				<el-table-column prop="fapzt" label="单据状态" min-width="100" align="center">
					<template slot-scope="scope">
						<!-- 发票状态 -1:草稿 0：入库保存；1：已审核；2：待开票；3：开票中；4：已开票；7：开票失败；8：暂不开票；9：已退票；34：无需开票 -->
						<p v-if="scope.row.fapzt == '-1'" style="color:#BEBEBE">草稿</p>
						<p v-if="scope.row.fapzt == '0'">待审核</p>
						<p v-if="scope.row.fapzt == '1'" style="color:#00DC16">已审核</p>
						<p v-if="scope.row.fapzt == '2'" style="color:#EE0101">待开票</p>
						<p v-if="scope.row.fapzt == '3'" style="color:#2F66FC">开票中</p>
						<p v-if="scope.row.fapzt == '4'" style="color:#FF8000">已开票</p>
						<p v-if="scope.row.fapzt == '5'" style="color:#FF8000">已作废</p>
						<p v-if="scope.row.fapzt == '6'" style="color:#FF8000">已红冲</p>
						<p v-if="scope.row.fapzt == '7'" style="color:#BEBEBE">开票失败</p>
						<p v-if="scope.row.fapzt == '8'" style="color:#00DC16">暂不开票</p>
						<p v-if="scope.row.fapzt == '9'" style="color:#00DC16">已退票</p>
						<p v-if="scope.row.fapzt == '10'" style="color:#00DC16">已合并</p>
						<p v-if="scope.row.fapzt == '21'" style="color:#00DC16">作废关闭中</p>
						<p v-if="scope.row.fapzt == '22'" style="color:#00DC16">作废重开中</p>
						<p v-if="scope.row.fapzt == '23'" style="color:#00DC16">作废锁定</p>
						<p v-if="scope.row.fapzt == '31'" style="color:#00DC16">未开发票冲销</p>
						<p v-if="scope.row.fapzt == '32'" style="color:#00DC16">已开发票冲销</p>
						<p v-if="scope.row.fapzt == '33'" style="color:#00DC16">作废冲销</p>
						<p v-if="scope.row.fapzt == '34'" style="color:#00DC16">无需开票</p>
						<p v-if="scope.row.fapzt == '35'" style="color:#00DC16">待作废</p>
					</template>
				</el-table-column>
				<el-table-column label="发票类型" prop="faplxdm" sortable="custom" min-width="100" align="center">
					<template slot-scope="scope">
						<p v-if="scope.row.faplxdm == '026'">电子普票</p>
						<p v-if="scope.row.faplxdm == '028'">电子专票</p>
						<p v-if="scope.row.faplxdm == '007'">纸质普票</p>
						<p v-if="scope.row.faplxdm == '004'">纸质专票</p>
					</template>
				</el-table-column>
				<el-table-column prop="fapdm" label="发票代码" sortable="custom" align="center" min-width="100"></el-table-column>
				<el-table-column prop="faphm" label="发票号码" sortable="custom" align="center" min-width="100">
					<template slot-scope="scope">
						<el-button type="text" @click="foryulan(scope.row)">{{ scope.row.faphm }}</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="goufmc" label="购方名称" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
				<el-table-column prop="hejje" label="金额" align="right" min-width="100">
					<template slot-scope="scope">
						<span>{{ toThousands(Amountformat(scope.row.hejje)) }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="hejse" label="税额" align="right" min-width="100">
					<template slot-scope="scope">
						<span>{{ toThousands(Amountformat(scope.row.hejse)) }}</span>
					</template>
				</el-table-column>
				<el-table-column label="开票日期" align="left" min-width="160px" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>{{ yyyyMMdd(scope.row.kaiprq) }}</span>
					</template>
				</el-table-column>
				<el-table-column label="主要商品名称" align="left" min-width="160px" show-overflow-tooltip>
					<template slot-scope="scope">
						<span v-if="notemptyandnull(scope.row.docDetails.length)">{{ scope.row.docDetails[0].shangpmc }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="yuanfpdm" label="原发票代码" align="center" min-width="110"></el-table-column>
				<el-table-column prop="yuanfphm" label="原发票号码" align="center" min-width="110"></el-table-column>
				<el-table-column prop="kaipr" label="开票人" align="center" min-width="100"></el-table-column>
				<el-table-column prop="zidysm" label="自定义说明" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
				<el-table-column prop="zidysm2" label="自定义说明二" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
				<el-table-column prop="kaipzddm" label="税盘编号" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
				<el-table-column fixed="right" label="操作" min-width="180" align="center">
					<template slot-scope="scope">
						<div class="Centerhorizontally">
							<el-button type="text" size="small" :style="scope.row.fapzt == '35' ? 'color:#BEBEBE' : ''" @click="docOneInvalid(scope.row, 1)">作废</el-button>
							<el-button type="text" size="small" @click="foryulan(scope.row)">预览发票</el-button>
							<el-button type="text" size="small" @click="docOneInvalid(scope.row, 2)">发票作废</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
import configHttp from '../../../../configHttp.js';
export default {
	components: {},
	data() {
		function formatDateTime(inputTime) {
			var date = new Date(inputTime);
			var y = date.getFullYear();
			var m = date.getMonth() + 1;
			m = m < 10 ? '0' + m : m;
			var d = date.getDate();
			d = d < 10 ? '0' + d : d;
			var h = date.getHours();
			h = h < 10 ? '0' + h : h;
			var minute = 0;
			var second = 0;
			minute = minute < 10 ? '0' + minute : minute;
			second = second < 10 ? '0' + second : second;
			return y + m + d + h + minute + second;
		}
		function gettimeone() {
			var data = new Date();
			data.setDate(1);
			data.setHours(0);
			data.setSeconds(0);
			data.setMinutes(0);
			return formatDateTime(data.getTime());
		}
		function getnowsmp() {
			var date = new Date();
			var year = date.getFullYear();
			var month = date.getMonth() + 1;
			var strDate = date.getDate();
			if (month >= 1 && month <= 9) {
				month = '0' + month;
			}
			if (strDate >= 0 && strDate <= 9) {
				strDate = '0' + strDate;
			}
			var d = date.getDate();
			d = d < 10 ? '0' + d : d;

			var currentdate = year + month + d + '235959';
			return currentdate;
		}
		return {
			searchlist: [
				{
					prop: 'faplxdm',
					label: '发票类型',
					type: 'select',
					selectval: [
						{
							label: '电子专票',
							value: '028'
						},
						{
							label: '纸质专票',
							value: '004'
						},
						{
							label: '全部',
							value: ''
						}
					]
				},
				{
					prop: 'faphm',
					label: '发票号码',
					type: 'input'
				},
				{
					prop: 'fapdm',
					label: '发票代码',
					type: 'input'
				},

				{
					prop: 'alldate',
					label: '开票日期',
					type: 'date',
					valueformat: 'yyyyMMdd'
				},
				{
					prop: 'yuanfphm',
					label: '原发票号码',
					type: 'input'
				},
				{
					prop: 'yuanfpdm',
					label: '原发票代码',
					type: 'input'
				},
				{
					prop: 'zfr',
					label: '作废人',
					type: 'input'
				},
				{
					prop: 'alldatezf',
					label: '作废日期',
					type: 'date',
					valueformat: 'yyyyMMdd'
				},
				{
					prop: 'goufmc',
					label: '购方名称',
					type: 'input'
				},
				{
					prop: 'kaipr',
					label: '开票人',
					type: 'input'
				},
				{
					prop: 'kaipzddm',
					label: '税盘编号',
					type: 'input'
				},
				{
					prop: 'zidysm',
					label: '自定义说明',
					type: 'input'
				}
			],
			kgdialog: false,
			kgtitle: ['列表'],
			isshou: true,
			tableDatans: [{}],
			tableDatakp: [{}],
			formLabelWidth: '150px',
			cxdialog: false,
			/* 开具弹框 */
			page: 1,
			pagenum: 10,
			totalcount: 0,
			tableData: [],
			headtitle: ['发票管理', '发票作废管理'],
			likeSearch: '',
			cxtitle: ['高级查询'],
			selectCount: 0,
			selectHejje: 0,
			selectHejse: 0,
			selectIds: [],
			selectRows: [],
			allitem: {},
			allitemList: [],
			outerVisible: false,
			selectIdsyq: [],
			selectRowsyq: [],
			serchform: {
				alldate: '' /*,[gettimeone(), getnowsmp()]*/,
				alldatezf: ''
			},
			serchformRules: {
				hejse: [{ validator: this.validateHejjeAndHejse, trigger: 'blur' }],
				hejje: [{ validator: this.validateHejjeAndHejse, trigger: 'blur' }],
				goufsbh: [{ validator: this.validateCustomersbh, trigger: 'blur' }],
				fapdm: [{ validator: this.validateFapdm, trigger: 'blur' }],
				faphm: [{ validator: this.validateFaphm, trigger: 'blur' }]
			},
			tableHeight: 0,
			currentpage: 1,
			elementui_page_component_key: '',
			choosetitleindex: '0',
			fpxlxoptions: [
				{
					label: '全部',
					value: ''
				},
				{
					label: '纸质专票',
					value: '004'
				},
				{
					label: '纸质普票',
					value: '007'
				}
			],
			documentStatus: '',
			isQuery: false,
			// 1、作废 2、作废重开
			type: '1',
			formlist: [
				{
					prop: 'text',
					label: '修改自定义说明二',
					type: 'textarea',
					isnotnull: true
				}
			],
			formdata: {
				text: ''
			},
			dialogApproval: false,
			sort: 'desc',
			order: 'id'
		};
	},
	created() {
		// this.getInvalidDocList();
	},
	mounted() {
		this.repairtable();
	},
	methods: {
		repairtable() {
			this.$nextTick(() => {
				this.tableHeight = this.diagheightzhengshutiankai();
				setTimeout(() => {
					this.$refs.multipleTable.doLayout();
				}, 300);
				window.onresize = () => {
					this.tableHeight = this.diagheightzhengshutiankai();
					setTimeout(() => {
						this.$refs.multipleTable.doLayout();
					}, 300);
				};
			});
		},
		closeouterVisible() {
			this.outerVisible = false;
		},
		foryulan(row) {
			console.log(row);
			this.allitem = JSON.parse(JSON.stringify(JSON.parse(row.cank0)));
			if (this.allitem.stateall.istaxincluded) {
				this.allitem.priceall.forEach(r => {
					if (r.unitPrice) {
						if (r.quantity && !isNaN(r.taxRate)) {
							r.unitPrice = (r.chooseMoney / (parseFloat(r.taxRate) + 1) / r.quantity).toFixed(15);
						}
						// 	let charLength = String(r.unitPrice).substring(String(r.unitPrice).lastIndexOf(".")+1).length;
						//  if(charLength>15){
						//       r.unitPrice = parseFloat(r.unitPrice).toFixed(15);
						//   }
						//   let charSuffix = String(r.unitPrice).substring(String(r.unitPrice).lastIndexOf(".")+1);
						//   if(charSuffix == '000000000000000'){
						//        r.unitPrice = parseFloat(r.unitPrice).toFixed(2);
						//   }
					}
					r.chooseMoney = r.chooseMoney - r.taxRatemoney;
					r.chooseMoney = parseFloat(r.chooseMoney).toFixed(2);
				});
			}
			this.documentStatus = this.allitem.documentStatus;
			this.outerVisible = true;
		},
		changeshou() {
			this.isshou = !this.isshou;
		},
		forchangetype() {
			this.currentpage = 1;
			this.elementui_page_component_key++;
			this.page = 1;
			this.selectIds = [];
			this.selectCount = 0;
			this.selectHejje = 0;
			this.selectHejse = 0;
			this.tableData = [];
			this.selectRows = [];
		},
		resetForm() {
			Object.keys(this.serchform).map(key => (this.serchform[key] = ''));
		},
		forshuai(e) {
			// if(this.emptyandnull(this.serchform.faplxdm)){
			// 	this.$message.error("发票类型不能为空")
			// 	return false
			// }
			this.isQuery = true;
			this.elementui_page_component_key++;
			this.currentpage = 1;
			if (this.serchform.alldate) {
				this.serchform.kaiprqStart = this.serchform.alldate[0];
				this.serchform.kaiprqEnd = this.serchform.alldate[1] + '235959';
			}
			if (this.serchform.alldatezf) {
				this.serchform.kaiprqStart = this.serchform.alldatezf[0];
				this.serchform.kaiprqEnd = this.serchform.alldatezf[1] + '235959';
			}

			this.getInvalidDocList(e);
		},
		/* 子传父 */
		closekgdialog(e) {
			this.kgdialog = e;
		},
		forcloseshai() {
			this.cxdialog = false;
		},
		forserchinput() {
			this.currentpage = 1;
			this.elementui_page_component_key++;
			this.page = 1;
			Object.keys(this.serchform).map(key => (this.serchform[key] = ''));
			this.getInvalidDocList();
		},
		/* 重置 */
		forrestsgai() {
			Object.keys(this.serchform).map(key => (this.serchform[key] = ''));
		},
		handleSizeChange(val) {
			this.pagenum = val;
			if (this.isQuery) {
				this.getInvalidDocList();
			}
		},
		handleCurrentChange(val) {
			this.page = val;
			this.getInvalidDocList();
		},
		/* 高级查询弹框	 */
		forserch() {
			this.cxdialog = true;
		},
		/**
		 * 作废数据查询
		 */
		getInvalidDocList(e) {
			var newform = JSON.parse(JSON.stringify(this.serchform));
			delete newform['alldate'];
			delete newform['alldatezf'];
			if (this.notemptyandnull(e)) {
				newform = {};
			}
			newform.type = this.choosetitleindex;

			let params = {
				likeSearch: this.likeSearch,
				search: newform,
				page: this.page,
				pagenum: this.pagenum,
				limit: this.pagenum,
				sort: this.sort,
				order: this.order
			};

			if (configHttp.shuangRiTaxNumber) {
				let shuangRiTaxNumber = configHttp.shuangRiTaxNumber;
				console.log(shuangRiTaxNumber);
				let userobj = JSON.parse(localStorage.getItem('useropj'));
				let qiybh = userobj.currCompany.code;
				if (shuangRiTaxNumber.includes(qiybh)) {
					params.search.cank3 = '3';
				}
			}

			this.$https.fetchPost('/inventory/getInvalidDocList', params).then(res => {
				this.tableData = res.data.data;
				this.totalcount = res.data.count;

				this.cxdialog = false;
			});
		},
		handleSelectionChange(e) {
			this.selectIds = [];
			this.selectCount = 0;
			this.selectHejje = 0;
			this.selectHejse = 0;
			let hejje = 0;
			let hejse = 0;
			let count = 0;
			this.selectRows = [];
			e.forEach((item, index) => {
				this.selectIds.push(item.id);
				count++;
				hejje = this.printFn(parseFloat(hejje) + parseFloat(item.hejje == '' ? '0' : item.hejje));
				hejse = this.printFn(parseFloat(hejse) + parseFloat(item.hejse == '' ? '0' : item.hejse));
				this.selectRows.push(item);
			});
			this.selectCount = count;
			this.selectHejje = hejje;
			this.selectHejse = hejse;
		},
		selectClick(row, column, event) {
			this.$refs.multipleTable.toggleRowSelection(row);
		},
		tableSortChange(column, prop, order) {
			this.order = column.prop;
			if (column.order) {
				this.sort = column.order.replace('ending', '');
			} else {
				this.sort = 'desc';
				this.order = 'id';
			}
			this.getInvalidDocList();
		},

		docInvalid(type) {
			this.type = type;
			let selectRows = this.selectRows;
			if (selectRows < 1) {
				this.$message({
					type: 'info',
					message: this.$tolertJSON['007-2']
				});
				return;
			}
			try {
				selectRows.forEach(item => {
					if (item.fapzt === '6') {
						throw new Error('发票号码' + item.faphm + '已被红冲，请先作废其对应的负数发票！');
					}
				});
			} catch (e) {
				this.$message({
					type: 'error',
					message: e.message
				});
				return;
			}

			let isInvalidDoc = false;
			this.$confirm('此操作将批量作废选择发票, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					console.log(selectRows);
					selectRows.forEach(item => {
						if (item.fapzt === '35') {
							isInvalidDoc = true;
							throw new Error();
						}
					});
					this.doDocInvalid(this.selectIds);
				})
				.catch(() => {
					if (isInvalidDoc) {
						this.$message({
							type: 'info',
							message: this.$tolertJSON['007-3']
						});
					} else {
						this.$message({
							type: 'info',
							message: '已取消作废'
						});
					}
				});
		},
		// 单张发票作废
		docOneInvalid(row, type) {
			this.type = type;
			this.selectRows[0] = row;

			let selectRows = this.selectRows;
			console.log('selectRows' + JSON.stringify(selectRows));
			if (selectRows < 1) {
				this.$message({
					type: 'info',
					message: this.$tolertJSON['007-2']
				});
				return;
			}
			try {
				selectRows.forEach(item => {
					if (item.fapzt === '6') {
						throw new Error('发票号码' + item.faphm + '已被红冲，请先作废其对应的负数发票！');
					}
				});
			} catch (e) {
				this.$message({
					type: 'error',
					message: e.message
				});
				return;
			}

			let isInvalidDoc = false;
			this.$confirm('此操作将作废选择发票, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					selectRows.forEach(item => {
						if (item.fapzt === '35') {
							isInvalidDoc = true;
							throw new Error();
						}
					});
					this.selectIds[0] = selectRows[0].id;
					this.doDocInvalid(this.selectIds);
				})
				.catch(() => {
					if (isInvalidDoc) {
						this.$message({
							type: 'info',
							message: this.$tolertJSON['007-3']
						});
					} else {
						this.$message({
							type: 'info',
							message: '已取消作废'
						});
					}
				});
		},
		// doDocInvalid(ids) {
		// 	this.$https.fetchPost('/inventory/doInvalidDoc', ids).then(res => {
		// 		if (res.data.success) {
		// 			this.getInvalidDocList();
		// 		} else {
		// 			this.$message.error(res.data.message);
		// 		}
		// 	});
		// },
		doDocInvalid(ids) {
			let jsonObject = {
				ids: ids,
				type: this.type
			};
			let json = JSON.stringify(jsonObject);
			this.$https.fetchPost('/inventory/doInvalidReopenDoc', json).then(res => {
				if (res.data.success) {
					this.getInvalidDocList();
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		doSingleInvalid(index, row) {
			this.$confirm('发票作废后无法恢复，请确定是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					if (row.fapzt == '5') {
						this.$message({
							type: 'info',
							message: this.$tolertJSON['007-3']
						});
						return;
					}
					if (row.fapzt == '6') {
						this.$message({
							type: 'error',
							message: '发票号码' + row.faphm + '已被红冲，请先作废其对应的负数发票！'
						});
						return;
					}
					let ids = [];
					ids.push(row.id);
					this.doDocInvalid(ids);
				})
				.catch(() => {});
		},
		doSerch(form) {
			this.$refs[form].validate(valid => {
				if (valid) {
					this.likeSearch = '';
					this.getInvalidDocList();
				} else {
					return false;
				}
			});
		},
		invalidSerchForm(type) {
			switch (type) {
				case 'fapdm':
					this.serchform.fapdm = this.serchform.fapdm.replace(/[^\d]/g, '');
					break;
				case 'faphm':
					this.serchform.faphm = this.serchform.faphm.replace(/[^\d]/g, '');
					break;
				case 'jine':
					this.serchform.hejje = this.serchform.hejje.replace(/[^-\d.]/g, '');
					break;
				case 'shuie':
					this.serchform.hejse = this.serchform.hejse.replace(/[^-\d.]/g, '');
					break;
				case 'goufsbh':
					this.serchform.goufsbh = this.serchform.goufsbh.replace(/[^\da-zA-Z]/g, '');
					break;
			}
		},
		submitFrom() {
			var param = {};
			param.ids = this.selectIds;
			param.text = this.formdata.text;

			this.$https.fetchPost('/doc/updateZidysm2', param).then(res => {
				if (res.data.success) {
					this.dialogApproval = false;
					this.getInvalidDocList();
				}
			});
		},
		//修改自定义说明二
		openUpdateZidysm2() {
			if (this.selectCount < 1) {
				this.$message({
					type: 'error',
					message: '请选择需要修改自定义说明的单据。'
				});
				return;
			}
			this.dialogApproval = true;
			if (this.$refs.taxform) {
				this.$nextTick(() => {
					this.$refs.taxform.clearValidate();
				});
			}
		}
	}
};
</script>

<style scoped="scoped" lang="less">
/deep/.el-input--suffix .el-input__inner {
	padding-right: 15px;
}
.shousuo:extend(.Verticalcenter) {
	height: 20px;
	margin-bottom: 10px;
	background-color: #f8f8f8;
}
.shousuo:hover {
	background: #f8f8f8;
}
.minheight {
	height: 50px;
	overflow: hidden;
	transition: all 0.3s ease;
}
.maxheight {
	height: 160px;
	overflow: hidden;
	transition: all 0.3s ease;
}
.tish {
	margin-left: 170px;
	margin-top: 10px;
}
.zuofei {
	.Centerupdown > div:extend(.end-flex) {
		font-size: 16px;
		width: 150px;
		margin-right: 20px;
	}
}

.Centerupdown {
}
/deep/.el-dialog__body {
	padding: 0;
}
/deep/.el-table--small td {
	padding: 4px 0;
}
/deep/.el-table__body-wrapper {
	min-height: 160px;
}
/deep/.el-tabs__header {
	margin: 0 0 0px !important;
}
.areatable {
	margin-top: 16px;
}
.areacontent {
	margin-left: 21px;
}
</style>
